/**
 * @param {{freeSpaceImage:any,tileCategories:any,hide_registeration_form:any}} data
 */
import url from "./url";

const {
  endpoints,
  baseApiUrl: baseUrl,
  baseApiUrlWithoutWin: baseUrlWithoutWin,
} = url;
// let d = new Date();
// let version = d.getTime();

const fetchCms = async (endpoint) => {
  try {
    const response = await fetch(`${baseUrl}${endpoint}`, {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-store",
      },
      cache: "no-store",
    });

    if (response.ok) {
      return await response.json();
    } else {
      throw response.statusText;
    }
  } catch (e) {
    throw e;
  }
};
const fetchCmsWithoutWin = async (endpoint) => {
  try {
    const response = await fetch(`${baseUrlWithoutWin}${endpoint}`, {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-store",
      },
      cache: "no-store",
    });

    if (response.ok) {
      return await response.json();
    } else {
      throw response.statusText;
    }
  } catch (e) {
    throw e;
  }
};

const fetchProfileZipCode = async (val) => {
  try {
    const response = await fetch(`${baseUrl}site-data?zipcode=${val}`, {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-store",
      },
      cache: "no-store",
    });

    if (response.ok) {
      return await response.json();
    } else {
      throw response.statusText;
    }
  } catch (e) {
    throw e;
  }
};

const postCms = async (endpoint, data) => {
  // TODO:
  try {
    const response = await fetch(`${baseUrl}${endpoint}`, {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-store",
      },
      method: "POST",
      mode: "cors",
      cache: "no-store",
      credentials: "same-origin",
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: JSON.stringify(data),
    });

    if (response.ok) {
      return await response.json();
    } else {
      throw response.statusText;
    }
  } catch (e) {
    throw e;
  }
};

const fetchNavigation = async () => {
  try {
    return await fetchCmsWithoutWin(endpoints.nav);
  } catch (e) {
    //console.log(e);
    return {};
  }
};

const fetchSiteData = async () => {
  try {
    return await fetchCms(endpoints.siteData);
  } catch (e) {
    //console.log(e);
    return {};
  }
};

const fetchFooterButtons = async () => {
  try {
    return await fetchCmsWithoutWin(endpoints.footer);
  } catch (e) {
    //console.log(e);
    return {};
  }
};

const fetchFooterLinks = async () => {
  try {
    return await fetchCmsWithoutWin(endpoints.footerMenu);
  } catch (e) {
    //console.log(e);
    return {};
  }
};

export const sendUniqueId = async (id) => {
  const data = { uuid: id };
  try {
    return await postCms("create-unique-id?_format=json", data);
  } catch (e) {
    return null;
  }
};

export const sendRegisterInformation = async (uid, uid_sign, uid_time) => {
  const data = {
    sig_timestamp: uid_time,
    uid: uid,
    uid_sig: uid_sign,
  };
  try {
    const json = await postCms("react-drupal-login?_format=json", data);
    //console.log("json", json);
    return json;
  } catch (e) {
    return null;
  }
};

export {
  fetchNavigation,
  fetchSiteData,
  fetchFooterButtons,
  fetchFooterLinks,
  fetchProfileZipCode,
};
export default {

  fetchNavigation,
  fetchSiteData,
  fetchFooterButtons,
  fetchFooterLinks,
  fetchProfileZipCode,
};
